import * as constants from '../constants';

export const requestHistory = (id, nodeId, propId, params) => ({type: constants.HISTORY_REQUESTED, payload: {id, nodeId, propId, params}});
export const historySuccess = (id, data) => ({type: constants.HISTORY_SUCCESS, payload: {id, data}});
export const historyFailure = (id, error) => ({type: constants.HISTORY_FAILURE, payload: {id, error}});
